import React from 'react';
import { Skeleton } from '@/components/shadcn/skeleton';
import { ScoutErrorType } from '@/types/location';
import NoImageryIcon from '@/components/ui/icons/NoImageryIcon';

interface Props {
  apiCallsComplete: boolean;
  errorReason?: ScoutErrorType;
}

export default function CarouselSkeleton({
  apiCallsComplete,
  errorReason,
}: Props) {
  return (
    <div
      data-complete={apiCallsComplete}
      className="group/skeleton no-scrollbar aspect-h-1 aspect-w-2 relative w-full overflow-hidden rounded-md data-[complete=true]:overflow-x-hidden">
      <div className="aspect-h-1 aspect-w-2 flex duration-1000 group-data-[complete=true]/skeleton:opacity-0">
        <Skeleton />
      </div>
      {errorReason === 'imagery' ? (
        <div className="absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-2 opacity-0 transition-all duration-1000 group-data-[complete=true]/skeleton:opacity-100">
          <NoImageryIcon />
        </div>
      ) : null}
    </div>
  );
}
